// src/components/Footer.js
import React from 'react';
import './Footer.css'; // This will be your CSS file for Footer styling

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/*<p>BonzAI offers access to over 100,000 crystallization condition predictions to accelerate scientific discovery.</p>*/}
        <p>Copyright © 2023-2024 bonzai-bio.com</p>
        {/* Add more footer content as needed */}
      </div>
    </footer>
  );
};

export default Footer;
